import useAPI from '@/hooks/useAPI';
import PersonRepository from '@/repositories/PersonRepository';
import { PeopleParams } from '@/repositories/PersonRepository/types';

const usePeople = ({ params, enabled = true }: { params: PeopleParams; enabled?: boolean }) => {
  const personRepository = PersonRepository();

  return useAPI({
    queryKey: ['getPeople', params],
    queryFn: async () => {
      return await personRepository.getPeople(params);
    },
    enabled
  });
};

export default usePeople;
